import React from "react";

const InBoxing = () => {
  return <div>Inboxing</div>;
};

export default InBoxing;
